// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btnStyling {
  color: #ffffff !important;
  background-color: #c11b2f !important;
  font-size: 16px !important;
  font-family: "Poppins", sans-serif;
  line-height: unset !important;
  letter-spacing: 0em;
  padding: 12px 40px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  height: unset !important;
  width: unset !important;
}
.btnStyling.addBtnCircle,
.btnStyling.backBtnCircle {
  padding: 0 !important;
  height: 44px !important;
  width: 44px !important;
  border-radius: 100% !important;
}
.btnStyling.addBtnCircle svg,
.btnStyling.backBtnCircle svg {
  padding: 0 !important;
}
.btnStyling:hover,
.btnStyling:active,
.btnStyling:focus {
  opacity: 0.8;
  color: #c11b2f !important;
  background-color: #ffffff !important;
  border-color: #c11b2f !important;
}
.btnStyling:hover .anticon-loading svg,
.btnStyling:active .anticon-loading svg,
.btnStyling:focus .anticon-loading svg {
  color: #c11b2f;
}
.btnStyling:focus {
  background-color: #77d0a7;
}
.btnStyling.white {
  background-color: #ffffff !important;
  color: #a3a3a3 !important;
  border: 1px solid #edf2f7;
}
.btnStyling.white:hover {
  background-color: #ffffff !important;
  color: #a3a3a3 !important;
  border-color: #c11b2f;
}
.btnStyling.white:hover .anticon-loading svg {
  color: #c11b2f;
}
.btnStyling.generatePassword {
  height: 45px !important;
  width: 45px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: unset !important;
  background-color: #ffffff !important;
}
.btnStyling.generatePassword svg {
  padding: unset;
  height: 20px;
  width: 20px;
}
.btnStyling.generatePassword svg path {
  fill: #c11b2f;
}
.btnStyling .textWhite {
  color: #ffffff !important;
}
.btnStyling svg {
  padding-right: 2px;
  height: unset;
  width: unset;
}
.btnStyling.ant-btn-loading {
  cursor: not-allowed;
}
.btnStyling.ant-btn-loading svg {
  padding-right: 0px !important;
  color: #ffffff;
}
.btnStyling.dropdownFilterButton {
  font-size: 14px !important;
  padding: 10px 30px !important;
  width: 94% !important;
  margin: 4px 0;
}
.btnStyling.downloadButton {
  background-color: transparent !important;
  padding: 0 !important;
  color: #c11b2f !important;
  border: unset !important;
  outline: unset !important;
  font-size: inherit !important;
}
.btnStyling.downloadButton.ant-btn-loading svg {
  padding-right: 0px !important;
  color: #c11b2f !important;
}
.btnStyling.anchorBtn {
  border: none !important;
  background-color: transparent !important;
  color: #606060 !important;
}
.btnStyling.rejectBtn {
  background-color: #f5cdcd !important;
  color: #c11b2f !important;
  border: 0 !important;
  padding: 4px 20px !important;
  font-size: 14px !important;
}
.btnStyling.approveBtn {
  background-color: #cdf5d3 !important;
  color: #39a84a !important;
  border: 0 !important;
  padding: 4px 20px !important;
  font-size: 14px !important;
}
.btnStyling.grayButton {
  background-color: #fff !important;
  color: grey !important;
  border: 1px solid grey;
  border-radius: 14px !important;
}
.btnStyling.yellow {
  background-color: #fdbb00 !important;
  color: #000000 !important;
}
.btnStyling[disabled] {
  color: #ffffff !important;
  border-color: #c11b2f !important;
  background: #c11b2f !important;
}
.btnStyling[disabled]:hover {
  opacity: 0.8 !important;
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .btnStyling {
    font-size: 14px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .btnStyling {
    font-size: 12px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .btnStyling {
    font-size: 12px !important;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .btnStyling {
    font-size: 12px !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .btnStyling {
    font-size: 14px !important;
    padding: 10px 20px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomButton/CustomButton.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,oCAAA;EACA,0BAAA;EACA,kCAAA;EACA,6BAAA;EACA,mBAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,uBAAA;AADF;AAGE;;EAEE,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,8BAAA;AADJ;AAJE;;EAOI,qBAAA;AACN;AAGE;;;EAGE,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;AADJ;AALE;;;EASM,cAAA;AACR;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,oCAAA;EACA,yBAAA;EACA,yBAAA;AAFJ;AAGI;EACE,oCAAA;EACA,yBAAA;EACA,qBAAA;AADN;AAFI;EAMM,cAAA;AADV;AAOE;EACE,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,oCAAA;AALJ;AAFE;EASI,cAAA;EACA,YAAA;EACA,WAAA;AAJN;AAPE;EAaM,aAAA;AAHR;AApEA;EA6EI,yBAAA;AANJ;AAvEA;EAiFI,kBAAA;EAEA,aAAA;EACA,YAAA;AARJ;AAUE;EACE,mBAAA;AARJ;AAOE;EAGI,6BAAA;EACA,cAAA;AAPN;AAWE;EACE,0BAAA;EACA,6BAAA;EACA,qBAAA;EACA,aAAA;AATJ;AAYE;EACE,wCAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,6BAAA;AAVJ;AAWI;EAEI,6BAAA;EACA,yBAAA;AAVR;AAeE;EACE,uBAAA;EACA,wCAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,0BAAA;AAdJ;AAiBE;EACE,oCAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;EACA,0BAAA;AAfJ;AAkBE;EACE,iCAAA;EACA,sBAAA;EACA,sBAAA;EACA,8BAAA;AAhBJ;AAkBE;EACE,oCAAA;EACA,yBAAA;AAhBJ;AAoBA;EACE,yBAAA;EACA,gCAAA;EACA,8BAAA;AAlBF;AAmBE;EACE,uBAAA;AAjBJ;AAoCA;EACE;IACE,0BAAA;EAlCF;AACF;AAuCA;EACE;IACE,0BAAA;EArCF;AACF;AA0CA;EACE;IACE,0BAAA;EAxCF;AACF;AA6CA;EACE;IACE,0BAAA;EA3CF;AACF;AAgDA;EACE;IACE,0BAAA;IACA,6BAAA;EA9CF;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.btnStyling {\n  color: @white-color !important;\n  background-color: @primary-color !important;\n  font-size: 16px !important;\n  font-family: @primary-font-family;\n  line-height: unset !important;\n  letter-spacing: 0em;\n  padding: 12px 40px !important;\n  font-weight: 500 !important;\n  box-shadow: none !important;\n  border-radius: 8px !important;\n  height: unset !important;\n  width: unset !important;\n\n  &.addBtnCircle,\n  &.backBtnCircle {\n    padding: 0 !important;\n    height: 44px !important;\n    width: 44px !important;\n    border-radius: 100% !important;\n    svg {\n      padding: 0 !important;\n    }\n  }\n\n  &:hover,\n  &:active,\n  &:focus {\n    opacity: 0.8;\n    color: @primary-color !important;\n    background-color: @white-color !important;\n    border-color: @primary-color !important;\n    .anticon-loading {\n      svg {\n        color: @primary-color;\n      }\n    }\n  }\n  &:focus {\n    background-color: @light-primary-color;\n  }\n\n  &.white {\n    background-color: @white-color !important;\n    color: @light-input !important;\n    border: 1px solid @lines-color;\n    &:hover {\n      background-color: @white-color !important;\n      color: @light-input !important;\n      border-color: @primary-color;\n      .anticon-loading {\n        svg {\n          color: @primary-color;\n        }\n      }\n    }\n  }\n\n  &.generatePassword {\n    height: 45px !important;\n    width: 45px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: unset !important;\n    background-color: @white-color !important;\n    svg {\n      padding: unset;\n      height: 20px;\n      width: 20px;\n      path {\n        fill: @primary-color;\n      }\n    }\n  }\n\n  .textWhite {\n    color: @white-color !important;\n  }\n\n  svg {\n    padding-right: 2px;\n    // font-size: 14px;\n    height: unset;\n    width: unset;\n  }\n  &.ant-btn-loading {\n    cursor: not-allowed;\n    svg {\n      padding-right: 0px !important;\n      color: @white-color;\n    }\n  }\n\n  &.dropdownFilterButton {\n    font-size: 14px !important;\n    padding: 10px 30px !important;\n    width: 94% !important;\n    margin: 4px 0;\n  }\n\n  &.downloadButton {\n    background-color: transparent !important;\n    padding: 0 !important;\n    color: @primary-color !important;\n    border: unset !important;\n    outline: unset !important;\n    font-size: inherit !important;\n    &.ant-btn-loading {\n      svg {\n        padding-right: 0px !important;\n        color: @primary-color !important;\n      }\n    }\n  }\n\n  &.anchorBtn {\n    border: none !important;\n    background-color: transparent !important;\n    color: @grey-input !important;\n  }\n\n  &.rejectBtn {\n    background-color: @light-red-badge-color !important;\n    color: @primary-color !important;\n    border: 0 !important;\n    padding: 4px 20px !important;\n    font-size: 14px !important;\n  }\n\n  &.approveBtn {\n    background-color: @light-green-badge-color !important;\n    color: @green-badge-color !important;\n    border: 0 !important;\n    padding: 4px 20px !important;\n    font-size: 14px !important;\n  }\n\n  &.grayButton {\n    background-color: #fff !important;\n    color: grey !important;\n    border: 1px solid grey;\n    border-radius: 14px !important;\n  }\n  &.yellow {\n    background-color: #fdbb00 !important ;\n    color: @black-color !important;\n  }\n}\n\n.btnStyling[disabled] {\n  color: @white-color !important;\n  border-color: @primary-color !important;\n  background: @primary-color !important;\n  &:hover {\n    opacity: 0.8 !important;\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .btnStyling {\n    font-size: 14px !important;\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  .btnStyling {\n    font-size: 12px !important;\n  }\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  .btnStyling {\n    font-size: 12px !important;\n  }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  .btnStyling {\n    font-size: 12px !important;\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  .btnStyling {\n    font-size: 14px !important;\n    padding: 10px 20px !important;\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
